import React, { useCallback, useEffect, useRef, useState } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NotificationSystem from 'react-notification-system'
import { createAuthApi } from 'utilities/api.js'
import flashMessageStyles from 'utilities/flashMessageStyles.js'
import LoadingScreen from 'components/VirtualPortal/components/LoadingScreen'
import MyProfilePhoto from 'components/VirtualPortal/Profile/MyProfilePhoto.jsx'
import VirtualPortalPreregistrationClosed from 'components/VirtualPortal/components/PreRegistration'
import Profile from 'components/VirtualPortal/Profile'
import Wishlist from 'components/VirtualPortal/Wishlist'
import WishlistRank from 'components/VirtualPortal/WishlistRank'
import Availability from 'components/VirtualPortal/Availability'
import Thankyou from 'components/VirtualPortal/Thankyou'
import Sessions from 'components/VirtualPortal/Sessions'
import VirtualPortalFooter from 'components/VirtualPortal/components/VirtualPortalFooter'
import VirtualPortalHeader from 'components/VirtualPortal/components/VirtualPortalHeader'
import setApi from 'components/VirtualPortal/helpers/setApi'
import InvalidTokenScreen from 'components/VirtualPortal/components/InvalidTokenScreen'
import 'moment-timezone'
import 'components/VirtualPortal/css/sessions.scss'
import 'components/VirtualPortal/css/buttonSlider.scss'


const Index = ({ token }) => {
  const notificationSystemRef = useRef(null)
  const [state, setState] = useState({
    isRefreshing: true,
    showErrorModal: false,
    fetchingErrorMessage: '',
    eventName: '',
    eventBeginDate: '',
    eventBeginTime: '',
    eventEndTime: '',
    eventTimeZone: '',
    emergencyBroadcastMessage: '',
    userFullName: '',
    userPhoto: '',
    userTitle: '',
    userOrganization: '',
    userDetails: {},
    desktopOrMobile: '',
    hasValidToken: true,
    isVirtualEvent: ''
  })

  useEffect(() => {
    const desktopOrMobile = () => {
      const windowSize = window.innerWidth
      const desktopOrMobile = (windowSize >= 767) ? 'desktop' : 'mobile'
      return desktopOrMobile
    }

    window.addEventListener('resize', desktopOrMobile)

    const fetchData = async () => {
      const api = window.api = createAuthApi({
        'SessionAuthorization': `${ token }`
      })

      const data = await setApi(api)
      return data
    }

    fetchData().then(data => {
      setState({ ...state, ...data, desktopOrMobile: desktopOrMobile() })
    })

  },[setApi])

  const flashMessage = useCallback((flashMessage) => {
    if(flashMessage) {
      flashMessage.position = 'tc'
      notificationSystemRef.addNotification(flashMessage)
    }
  },[])

  const handleTokenInputChange = useCallback((event) => {
    setState({...state, tokenInputValue: event.target.value})
  },[state])

  const handleTokenSubmit = useCallback((event) => {
    event.preventDefault()
    window.location = window.location.origin + '/' + state.tokenInputValue
  },[state])

  if(!state.hasValidToken) {
    return <InvalidTokenScreen
      tokenInputValue={state.tokenInputValue}
      handleTokenInputChange={handleTokenInputChange}
      handleTokenSubmit={handleTokenSubmit}
      tokenfetchingErrorMessage={state.fetchingErrorMessage} />
  }

  return(
    <div className='virtual-portal-content'>
      <NotificationSystem
        ref={ notificationSystemRef }
        style={ flashMessageStyles }
      />
      <div className='header-router-footer'>
        <div className='header-router'>
          <BrowserRouter>
            { state.isRefreshing ? <LoadingScreen /> :
              <div>
                <VirtualPortalHeader
                  eventName={state.eventName}
                  eventHasPeerToPeer={state.eventHasPeerToPeer}
                  eventBeginDate={state.eventBeginDate}
                  eventBeginTime={state.eventBeginTime}
                  eventEndTime={state.eventEndTime}
                  eventTimeZone={state.eventTimeZone}
                  peerToPeerWizardIsAvailable={state.peerToPeerWizardIsAvailable}
                  userRegistrationStatus={state.userRegistrationStatus}
                />
                { state.emergencyBroadcastMessage &&
                  <div className='emergency-broadcast-section'>
                    <div className='header-emergency-broadcast'>
                      <div className="container"><strong>ANNOUNCEMENT</strong></div>
                      <div className="container body-emergency-broadcast">
                        <p dangerouslySetInnerHTML={{ __html: state.emergencyBroadcastMessage }}></p>
                      </div>
                    </div>
                  </div>
                }
                <div className="virtual-portal">
                  {/* we only want to close the switching below to in person p2p setups which utilizes below code --  */}
                  <Switch>
                    <Route
                      path='/:token/profile/edit_photo/:wizard?'
                      render={ (router) =>
                        <div className='container'>
                          <MyProfilePhoto
                            router={router}
                            flashMessage={flashMessage}
                          />
                        </div>
                      }
                    />
                    <Route
                      path='/:token/availability/:wizard?'
                      render={ (router) =>
                        <div className='container'>
                          { state.peerToPeerWizardIsAvailable ?
                            <Availability
                              router={router}
                              peerToPeerWizardIsAvailable={state.peerToPeerWizardIsAvailable}
                            />
                            : <VirtualPortalPreregistrationClosed
                              isVirtualEvent />}
                        </div>
                      }
                    />
                    <Route
                      path='/:token/thankyou/:wizard?'
                      render={ (props) =>
                        <div className='container'>
                          <Thankyou {...props}
                            currentUser={state.userDetails}
                            fromWebApp={false}
                          />
                        </div>
                      }
                    />
                    <Route
                      path='/:token/thankyouweb'
                      render={ (props) =>
                        <div className='container'>
                          <Thankyou {...props}
                            currentUser={state.userDetails}
                            fromWebApp
                          />
                        </div>
                      }
                    />
                    <Route
                      path='/:token/wishlist_rank/:wizard?'
                      render={ (router) =>
                        <div className='container'>
                          { state.peerToPeerWizardIsAvailable ?
                            <WishlistRank
                              router={router}
                              peerToPeerWizardIsAvailable={state.peerToPeerWizardIsAvailable}
                            />
                            : <VirtualPortalPreregistrationClosed
                              isVirtualEvent />}
                        </div>
                      }
                    />
                    <Route
                      path='/:token/wishlist/:wizard?'
                      render={ (router) =>
                        <div className='container'>
                          { state.peerToPeerWizardIsAvailable ?
                            <Wishlist
                              router={router}
                              peerToPeerWizardIsAvailable={state.peerToPeerWizardIsAvailable}
                            />
                            : <VirtualPortalPreregistrationClosed
                              isVirtualEvent />}
                        </div>
                      }
                    />
                    <Route
                      path='/:token/profile/:wizard?'
                      render={ (router) =>
                        <div className='container'>
                          <Profile
                            router={router}
                            flashMessage={flashMessage}
                            peerToPeerWizardIsAvailable={state.peerToPeerWizardIsAvailable}
                          />
                        </div>
                      }
                    />
                    <Route
                      path='/:token'
                      render={ (props) =>
                        <div>
                          <Sessions {...props}
                            peerToPeerWizardIsAvailable={state.peerToPeerWizardIsAvailable}
                          />
                        </div>
                      }
                    />
                  </Switch>
                </div>
              </div>
            }
          </BrowserRouter>
        </div>
        <VirtualPortalFooter/>
      </div>
    </div>

  )

}

export default Index
